import * as React from "react";
import {Button, Icon, Label} from "semantic-ui-react";
import {backend} from "../../../../../../xconvert-backend";
import {authentication} from "../../../../../../authentication";
import {Queue, QueueWithEvent} from "../../../../../../generated/index";
import AceEditor from "react-ace";

export interface TestSuppressionScriptModalSingleProps {
    queue: Queue
    updateResponse: (xRequestId: string, output: string) => void
}

export function TestSuppressionScriptModalSingle(props: TestSuppressionScriptModalSingleProps) {
    const [event, setEvent] = React.useState("")

    async function test() {
        let auth = backend.withTokenAuthHeader(authentication.token)
        let request = {} as QueueWithEvent
        request.queue = props.queue
        request.events = []
        request.events.push(JSON.parse(event))

        let response = await fetch('/api/queues/testSuppressionScriptTest', {
            method: 'POST',
            headers: {
                "Authorization": auth.headers.Authorization.toString(),
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(request)
        })

        props.updateResponse(
            response.headers.get("x-request-id"),
            (await response.json()).events
        )
    }

    return <>
        <div
            style={{
                marginBottom: 5,
            }}
        >
            <Label>Input QueuedEvent</Label>
            <Button
                primary
                icon
                labelPosition="left"
                style={{float: "right"}}
                disabled={event == ""}
                onClick={() => test()}
            >
                <Icon name="play" />
                Test
            </Button>

        </div>

        <AceEditor
            theme="monokai"
            mode='groovy'
            value={event}
            width="100%"
            height="800px"
            readOnly={false}
            onChange={(value) => setEvent(value)}
        />
    </>
}
